import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Api from '../../utils/Api';
import Swal from 'sweetalert2';

export default function VerifyEmail() {
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        Api.get(`/verify-company/${token}`)
            .then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Aussteller aktiviert',
                    // title: 'Email Verified',
                    text: response.data.message,
                    confirmButtonColor: '#000',
                    iconColor: '#000'
                });
                navigate('/'); // Redirect to login page after successful verification
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Überprüfung fehlgeschlagen',
                    // title: 'Verification Failed',
                    text: error.response ? error.response.data.message : 'Etwas ist schief gelaufen!',
                    confirmButtonColor: '#000',
                    iconColor: '#000'
                });
            });
    }, [token, navigate]);

    return <div>Verifying...</div>;
}
